import { API_MAX_RESULTS } from "@consts";
import {
	WORDLE_MOD,
	getHighlightSegments,
	getSearchParamsFromRoute,
	getWordleMod,
} from "@utils";
import { getRequestMediator } from "~/common/modules/request-mediator";
import { getServiceEndpointProvider } from "~/common/modules/service-endpoint-provider";

export default {
	async onSeeMoreButtonClick(buttonMode) {
		if (buttonMode === "All") {
			if (!this.tableWordsExtended.length) {
				const requestMediator = getRequestMediator(
					this.$route,
					getServiceEndpointProvider(this.$axios, this.$config)
				);

				const params = getSearchParamsFromRoute(this.$route);

				this.loadingMoreWords = true;
				const response = await requestMediator.get(params.clean, {
					word_length: this.wordLength,
					offset: 35,
					limit: API_MAX_RESULTS,
					order_by:
						params.clean?.misc?.order_by ||
						this.currentSort ||
						"score",
				});
				this.loadingMoreWords = false;

				const augmentedResults = requestMediator?.formatResults(
					response?.data?._augment?._groups || []
				);

				const results = requestMediator?.formatResults(
					response?.data?._groups || []
				);

				const mappedResult = results[this.wordLength]?._items || [];
				const mappedAugmented =
					augmentedResults[this.wordLength]?._items || [];

				this.tableWordsExtended = [...mappedResult, ...mappedAugmented];
			}
			this.itemsToShow = API_MAX_RESULTS;
		} else if (buttonMode === "More") {
			this.itemsToShow = this.secondWordCount;
		} else if (buttonMode === "Less") {
			window.scrollTo(0, this.$el.offsetTop - 185);
			this.itemsToShow = this.initialWordsCount;
		}
	},
	/**
	 * The colour for one run of letters in a pill. The design drops the letter
	 * colouring entirely while a pill's definition is open, so the open state
	 * falls through to the pill's own text colour.
	 * @param {String} mod A single mod character
	 * @param {Boolean} [isDefinitionOpen]
	 * @returns {String} A text colour class, or "" for no override
	 */
	getSegmentClass(mod, isDefinitionOpen = false) {
		if (isDefinitionOpen) {
			return "";
		}

		switch (mod) {
			case WORDLE_MOD.CORRECT:
				return "text-wordle-green";
			case WORDLE_MOD.PRESENT:
				return "text-wordle-yellow";
			default:
				return "";
		}
	},
	/**
	 * Splits a word into same-mod runs for the pill layout, using the mods
	 * synthesised from the Wordle search params where there are any, and the
	 * API's own `_mod` everywhere else. Both vocabularies render identically,
	 * so this stays a single path if the API ever starts supplying Wordle mods.
	 * @param {{ word: String, mod: String }} word
	 * @returns {{ text: String, mod: String }[]}
	 */
	getWordHighlightSegments(word) {
		const params = this.wordleHighlightParams;
		const mod = params
			? getWordleMod(word.word, params.correct, params.includes)
			: word.mod;

		return getHighlightSegments(word.word, mod);
	},
	highlightWord(word, mod) {
		if (typeof word !== "string") {
			return "";
		}
		if (typeof mod !== "string") {
			return word;
		}
		let highlighted = mod
			.split("")
			.map((m, i) => {
				const letter = word[i];
				return m === "r" ? letter : `<strong>${letter}</strong>`;
			})
			.join("");
		highlighted = highlighted.replace(/<\/strong><strong>/g, "");
		return highlighted;
	},
	onLoadWords(params) {
		this.$router.push({ query: { ...this.$route.query, ...params } });
	},
	handleOpenedDef(wordIndex) {
		this.$set(this.definitionStates, wordIndex, true);
	},
	handleClosedDef(wordIndex) {
		this.$set(this.definitionStates, wordIndex, false);
	},
};
